module.exports = __webpack_public_path__ + "img/hb-bottom.2e5b44c8.png";